import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/core';

import theme from '@app/styles/theme';
import Table from '@app/shop/components/Table';

import { rem } from '@app/styles/theme/layout';
import { screenExtraSmall } from '@app/styles/theme/breakpoints';

export const SuccessTable = styled(Table)`
  & td {
    padding: 0.8rem 0;
  }

  & thead {
    td {
      padding-top: 0;
    }

    & [data-table='success-order-number'] {
      font-weight: bold;
    }
  }

  & thead,
  & tbody {
    td {
      font-weight: normal;
      border: none;
      text-align: left;
    }
  }

  & tbody {
    & [data-table='success-simple-row'] td {
      padding-bottom: 0;
    }

    & [data-table='success-simple-row-value'] {
      text-align: end;
    }

    & [data-table='success-shipping-value-free'] {
      color: ${theme.colors.gradientGreen};
    }

    & [data-table='success-order-details'] {
      td {
        border-top: 1px solid ${theme.colors.lightGray};
        padding-bottom: 0;
      }
    }
  }
`;

SuccessTable.defaultProps = { alternateRows: false };

export const iconStyles: SerializedStyles = css`
  padding: 0.5rem 0;
`;

export const NextStepsGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 100%;

  @media (min-width: ${screenExtraSmall}) {
    grid-template-columns: 45% 55%;
  }

  @media (max-width: ${screenExtraSmall}) {
    & img {
      grid-row-start: 1;
    }
  }
`;

/* screenExtraSmall is not exported in theme.breakpoints,
 * therefore we cannot use Box's py with responsive styles
 * for that screen */
export const nextStepsRowStyles = css`
  @media (max-width: ${screenExtraSmall}) {
    padding-top: ${rem(20)};
    padding-bottom: ${rem(20)};
  }
`;

export const nextStepsDescriptionStyles = css`
  @media (max-width: ${screenExtraSmall}) {
    display: none;
  }
`;

export const nextStepImageStyles = css`
  vertical-align: middle;
  float: right;
  width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

export const neutralCardStyles = css`
  margin: 0;
  padding: 0;
  border: 0;
`;
